const specs = {
  standard: {
    operation: 'create',
    create: {
      type: 'bool',
      product: 'model360_standard',
    },
  },
  premium: {
    operation: 'create',
    create: {
      type: 'bool',
      product: 'model360_premium',
    },
  },
  droneShooting: {
    operation: 'update',
    update: {
      type: 'mapTo',
      target: '@{product.id} == "model360_standard" || @{product.id} == "model360_premium"',
      mapTo: [ 'droneShooting' ],
    },
  },
};


const dependencies = {
  hard: [],
  soft: [
    {
      if: {
        key: 'droneShooting',
        value: true,
      },
      then: {
        operation: 'createOrUpdate',
        createOrUpdate: {
          product: 'droneShooting_standard',
          service: 'droneShooting',
          with: { model360: true },
        },
      },
    }
  ],
};


export default { specs, dependencies };
